/**
 * Values strip — mobile swipe dots.
 */
(function () {
  var MQ = '(max-width: 749px)';

  function itemsOf(track) {
    return Array.from(track.querySelectorAll('.auracase-values__item'));
  }

  function dotsOf(section) {
    return Array.from(section.querySelectorAll('.auracase-values__dot'));
  }

  function indexFromScroll(track) {
    var items = itemsOf(track);
    if (!items.length) return 0;
    var origin = items[0].offsetLeft;
    var x = track.scrollLeft + origin;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i += 1) {
      var dist = Math.abs(items[i].offsetLeft - x);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function setActiveDot(section, index) {
    dotsOf(section).forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function goTo(track, section, index) {
    var items = itemsOf(track);
    if (!items.length) return;
    var safe = Math.max(0, Math.min(items.length - 1, index));
    var origin = items[0].offsetLeft;
    track.scrollTo({
      left: Math.max(0, items[safe].offsetLeft - origin),
      behavior: 'smooth',
    });
    setActiveDot(section, safe);
  }

  function initDots(section) {
    if (section.dataset.valuesReady === 'true') return;
    var track = section.querySelector('.auracase-values__list');
    var dots = dotsOf(section);
    if (!track || dots.length < 2) return;

    section.dataset.valuesReady = 'true';

    var scrollTimer = 0;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActiveDot(section, indexFromScroll(track));
        }, 60);
      },
      { passive: true }
    );

    track.addEventListener('scrollend', function () {
      setActiveDot(section, indexFromScroll(track));
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (!window.matchMedia(MQ).matches) return;
        var idx = parseInt(dot.dataset.slideIndex || '0', 10);
        goTo(track, section, idx);
      });
    });

    setActiveDot(section, indexFromScroll(track));
  }

  function initAll() {
    document.querySelectorAll('.auracase-values').forEach(function (section) {
      section.dataset.valuesReady = '';
      initDots(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('.auracase-values')
        : null;
    if (section) {
      section.dataset.valuesReady = '';
      initDots(section);
    } else {
      initAll();
    }
  });
})();
